import { ComponentType, ReactNode } from 'react';

import { observer } from 'mobx-react-lite';

import { ApplicantCardTags } from '@components/applicant-card';
import { Badge } from '@components/badge';
import { IconAppConnect } from '@components/icons/app-connect';
import { IconPersonAdd } from '@components/icons/person-add';
import { IconReject } from '@components/icons/reject';
import { IconTeam } from '@components/icons/team';

import { useIntegrationLabels } from 'hooks/use-integration-labels';
import { useStore } from 'models/Provider';
import { IApplication } from 'models/types';

type ApplicationLabelsProps = {
  application: IApplication;
  wrapper?: ComponentType<{ children: ReactNode }>;
};

export const ApplicationLabels = observer<ApplicationLabelsProps>(function ApplicationLabels({
  application,
  wrapper: Wrapper = ApplicantCardTags,
}) {
  const { t } = useStore();
  const isNew = application.userRead && !application.userRead.newApplication;
  const integrationsLabels = useIntegrationLabels(application.integrationsResults);

  return (
    <Wrapper>
      {application.referredBy && (
        <Badge variant="blue" icon={<IconTeam />} text={t('application.label.sourced')} />
      )}
      {application.isNotifiedOfRejection && (
        <Badge variant="red" icon={<IconReject />} text={t('application.label.notified')} />
      )}
      {isNew && <Badge variant="green" text={t('application.label.new')} />}
      {application.isManuallyAdded && (
        <Badge
          variant="purple"
          icon={<IconPersonAdd />}
          text={t('application.label.manuallyadded')}
        />
      )}
      {integrationsLabels?.map((label) => (
        <Badge
          key={label.text}
          variant={label.variant}
          icon={<IconAppConnect />}
          text={label.text}
        />
      ))}
    </Wrapper>
  );
});
